import React, { useEffect, useState } from "react";
import { getDashboardAnalyticsForCurrentMonth } from "service/analytics.service";

const DailyOverAllAnalytics = () => {
  const [analyticsData, setAnalyticsData] = useState([]);

  useEffect(() => {
    // Fetch the analytics data from the API endpoint
    fetchDashboardAnalyticsForCurrentMonthDates();
  }, []);

  const fetchDashboardAnalyticsForCurrentMonthDates = async () => {

    try {
      const analytics = await getDashboardAnalyticsForCurrentMonth();
      console.log(analytics);
      setAnalyticsData(analytics.data.dailyAnalytics.reverse());

    //   setAnalytics(analytics.data);
    //   setOfferTypeData(offertype.data.offerTypeFeed);
    // setChartData(analytics.data.lineGraphData );
    } catch (error) {
      console.error('Error fetching advertisers:', error);
    }
  
  
  };

  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Date</th>
            <th>Revenue</th>
            <th>Payout</th>
            <th>Clicks</th>
            <th>Conversion</th>
            <th>Conversion Rate</th>
          </tr>
        </thead>
        <tbody>
          {analyticsData.map((item) => (
            <tr key={item.id}>
              <td>{item.date}</td>
              <td>{item.totalRevenue}</td>
              <td>{item.totalPayout}</td>
              <td>{item.totalClick}</td>
              <td>{item.totalConversion}</td>
              <td>{item.conversionRate}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DailyOverAllAnalytics;
